import React, { useEffect, useState } from "react";
import { AvField, AvForm } from "availity-reactstrap-validation"
import Select from "react-select";
import { toast } from "react-toastify";
import { Row, Col, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Label } from 'reactstrap'
import ShapeImgModal from "../ShapeImgModal"

const shapes = [
    { value: 'Circle', label: 'Circle' },
    { value: 'Rect', label: 'Rect' },
    { value: 'Cubic', label: 'Cubic' },
    { value: 'node', label: 'node' },
    { value: 'Pin', label: 'Pin' },
    { value: 'Arrow', label: 'Arrow' },
    { value: 'Build', label: 'Build' }
]
const hotspots = [
    { value: '2', label: 'Building 1', type: "building" },
    { value: '2', label: 'Building 2', type: "building" },
    { value: '25', label: 'villa', type: "unit" },
    { value: '24', label: 'villa', type: "unit" },
    { value: '14', label: 'property 1', type: "appartment" },
    { value: '41', label: 'property 1', type: "appartment" },
]

const customizeTypes = (type) => {
    if (!type || type === "none") {
        return hotspots
    } else {
        return hotspots.filter(item => {
            if (type.type === "building") {
                return item.type === "appartment"
            } else if (item.type !== type.type) {
                return item
            }
        })

    }
}
const Shape = ({
    setHeaderList, headerList,
    item,
    index,
    moveHander,
    addBuilding,
    removeShapeHandler,
    removeMoreShapeHandler,
    addShapeImgHandler,
    addSelectedUnit,
    titleHandler,
    radioChangeHandler,
    checkboxChangeHandler,
    selectAllHandler,
    shapeTypeHandler,
    hotspotTypeHandler,
    customizeTypesHandler,
    updateFloor,
    toggleUnitModal,
    buildingErrors,
    changeNodeColor,
    changeNodeOpacity,
    toggleMainImageModal }) => {
    const [floor, setFloor] = useState('')
    const [dropdownOpen, setDropdownOpen] = useState(false)
    const [dropdownMasterOpen, setDropdownMasterOpen] = useState(false)
    const [shapeIndex, setShapeIndex] = useState("")
    const toggle = () => setDropdownOpen(prevState => !prevState)
    const toggleMaster = () => setDropdownMasterOpen(prevState => !prevState)
    const [shapeImgModal, setShapeImgModal] = useState(false)
    const [selectAll,setSelectAll] = useState(false)

    useEffect(()=>{
        if(!!item?.hotspot){
            setFloor(item.hotspot?.floor)
        }
    },[])

    return (
        <>
            {index == 0 && <div 
                className="d-flex justify-content-between my-2 pt-3 pb-2 ms-2"
                style={{backgroundColor: '#EFF2F6', borderRadius: '8px'}} >
                <div>
                    <label>
                        <input
                        className="me-2"
                        type="checkbox" id="html" name="highlight"
                        checked={selectAll}
                        onChange={e=>{
                            selectAllHandler(e.target.checked)
                            setSelectAll(e.target.checked)
                            }} />
                        Select All
                    </label>
                </div>
                <Dropdown className="dropdownWidth mx-4 removebtnhover" color="light" isOpen={dropdownMasterOpen} toggle={toggleMaster}>
                            <DropdownToggle caret style={{paddingTop: '0'}} >
                                <i className="fas fa-ellipsis-h  text-dark fa-lg"></i>
                            </DropdownToggle>
                            <DropdownMenu>
                                {item.hotspot?.type == 'unit' && <>
                                <DropdownItem onClick={toggleMainImageModal}>
                                    Upload Main Image
                                </DropdownItem>
                                <DropdownItem onClick={() => toggleUnitModal()}>
                                    Upload Sub Images
                                </DropdownItem>
                                </>}
                                <DropdownItem 
                                 className="text-danger"
                                onClick={() => {
                                    removeMoreShapeHandler()
                                    toggleMaster
                                    setSelectAll(false)
                                }} >Remove Hotspots</DropdownItem>
                            </DropdownMenu>
                        </Dropdown>
            </div>}
            <Row className="mb-4">
                <Col sm={12} md={1} className="m-0 px-0 d-flex align-items-center ">
                    <div className="d-flex">
                        <input
                            className="mt-4 mx-1"
                            type="radio" 
                            id={`next`} 
                            name="next"
                            checked={item?.next}
                            style={{ width: '17px', height: '17px', accentColor: 'green' }}
                            onChange={()=> radioChangeHandler()}
                        />
                        <input
                            className="mt-4 mx-1"
                            type="checkbox" id={`html${index}`} name="highlight-checkbox"
                            checked={item ?.highlight}
                            onChange={e=> {
                                checkboxChangeHandler(e.target.checked, 'checkbox')
                            }}
                        />
                    </div>
                    <div className="mt-0 ms-2">
                        <Label>Photo</Label>
                        {item ?.idImage ?.path ? <img
                            style={{ height: "40px", width: "40px", objectFit: "cover", overflow: "hidden", borderRadius: "8px" }}
                            src={item ?.idImage ?.path} 
                            onClick={() => {  
                                setShapeIndex(index)
                                setShapeImgModal(true)
                            }}
                            />
                            : <div className="m-0 p-1 bg-light" style={{ borderRadius:"8px"}} >
                            <button type="button" className=" px-1 py-0  btn-upload  font-size-18 font-weight-bold"
                                style={{ height: "30px", width: "30px" ,background:"none",border: "1px #cadff7 dashed", borderRadius:"8px" }}
                                onClick={() => {  
                                    setShapeIndex(index)
                                    setShapeImgModal(true)
                                }} >
                                    +</button>
                            </div>
                         }
                    </div>
                </Col>
                <Col sm={12} md={(item?.type == 'node' || item?.type =='Cubic') ? 2 : 3} style={{paddingLeft: '22px'}}>
                    <AvForm className="position-relative">
                        <label className={`${(buildingErrors[item.title]) ? "error-text" : ''}`}>Title</label>
                        <AvField
                            name='ar'
                            className={`form-control ${(buildingErrors[item.title]) ? "error-text" : ''}`}
                            placeholder={"Phase Name"}
                            style={{borderColor: `${(buildingErrors[item.title]) ? "#f46a6a" : '#ced4da'}`}}
                            bsSize="lg"
                            value={(item?.hotspot?.value == 'none' || item?.hotspot?.value == "addBuilding") ? item?.title : item ?.hotspot?.label?.split('/')[0]}
                            onChange= {(e)=> titleHandler(e)}
                            onBlur={()=> {
                                if(item?.hotspot?.value == "addBuilding") addBuilding(item?.title, item.hotspot)
                            }}
                            disabled={(item?.hotspot?.value == 'none' || item?.hotspot?.value == "addBuilding") ? false : true}
                        />
                        {(buildingErrors[item.title]) && <p className="error-text font-size-11 m-0 position-absolute">Building Already Exist</p>}
                    </AvForm>
                </Col>
                {(item?.type == 'node' || item?.type =='Cubic') && <Col sm={12} md={1} className='p-0'>
                    <div className="position-relative d-flex" style={{gap: '8px'}}>
                        <div style={{display: 'table-caption'}}>
                            <label>Color</label>
                            <input 
                                type='color' 
                                className="mt-2"
                                style={{width: '30px'}}
                                value={item.fill} 
                                onChange={(e)=> changeNodeColor(e.target?.value)} />
                        </div>
                        <div style={{display: 'table-caption'}}>
                            <label>Opacity</label>
                            <input 
                                type='range' 
                                className="mt-3"
                                style={{width: '50px'}}
                                value={item?.opacity} 
                                min={0.2} max={1} step={.1}
                                onChange={(e)=> changeNodeOpacity(parseFloat(e.target.value))} />
                        </div>
                    </div>
                </Col>}
                <Col sm={12} md={item?.hotspot?.type == 'unit' ? 2 : 3}>
                    <div>
                        <label>Shape Type</label>
                        <Select
                            placeholder='Select'
                            options={shapes}
                            // options={shapes.filter(shape => shape.value === item ?.selectedShape)}
                            onChange={(data) => shapeTypeHandler(data)}
                            value={item ?.selectedShape}
                        />
                    </div>
                    {/* {standalone => number of floor inside=> floor number} */}
                </Col>
                {item?.hotspot?.type == 'unit' && <Col md={2}>
                    <AvForm>
                        <AvField
                            name='floor_num'
                            className='form-control'
                            placeholder={item.hotspot?.check !== 'inBuilding' ? "Number of Floors" : "Floor Number"}
                            label={item.hotspot?.check !== 'inBuilding' ? "Number of Floors" : "Floor Number"}
                            bsSize="lg"
                            value={floor}
                            type='number'
                            min={"0"}
                            onChange= {(e)=> setFloor(e.target.value)}
                            onBlur={updateFloor}
                        />
                    </AvForm>
                </Col>}
                <Col sm={12} md={item.hotspot?.type == 'unit' ? 2 : 3}>
                    <label>Hotspot Type</label>
                    <Select
                        placeholder='Select'
                        options={customizeTypesHandler}
                        onChange={(data) => {
                            hotspotTypeHandler(data)
                        }}
                        value={item ?.hotspot}
                    />
                </Col>
                <Col sm={12} md={1} >
                <Label>Action</Label>
                    <button style={{fontSize:"0.92rem"}} 
                        disabled={buildingErrors[item?.title]}
                        className="btn btn-white border-light border-2 py-2 px-4 " 
                        onClick={() => {
                        if (!item ?.idImage) {
                            toast.error("upload photo  First")
                            return
                        } else if (!item ?.hotspot) {
                            toast.error("Select hotspot type")
                            return
                        } else if(!item.title){
                            toast.error("Enter Title")
                            return
                        }
                        else {
                            const updatedList = [...headerList, item.idImage]
                            setHeaderList([...updatedList])
                            if(item ?.hotspot.type === 'unit'){
                                addSelectedUnit(item ?.hotspot.id)
                            }
                            let hotspot = {...item?.hotspot}
                            if(item ?.hotspot.value == 'addBuilding'){
                                hotspot = {...item?.hotspot, title: item ?.title}
                            }
                            moveHander(item ?.idImage, item ?.title, hotspot)
                            window.scrollTo({
                                top: 0,
                                behavior: 'smooth'
                            })

                        }
                    }}>Next</button>
                </Col>

                <Col sm={12} md={1} className='d-flex align-items-center'>
                    <Dropdown className={`dropdownWidth removebtnhover mt-4 mx-4`} color="light" isOpen={dropdownOpen} toggle={toggle}>
                            <DropdownToggle caret>
                                <i className="fas fa-ellipsis-h text-dark fa-lg"></i>
                            </DropdownToggle>
                            <DropdownMenu>
                            {item ?.idImage ?.path ?
                             <DropdownItem 
                             onClick={() => {
                                    setShapeIndex(index)
                                    setShapeImgModal(true)

                                }} >Edit Photo</DropdownItem> :null}
                                <DropdownItem 
                                 className="text-danger"
                                onClick={removeShapeHandler} >Remove Hotspot</DropdownItem>
                            </DropdownMenu>
                        </Dropdown>  
                </Col>
            </Row>
            {shapeImgModal && 
                <ShapeImgModal 
                    hotspot={item.hotspot} 
                    image={item ?.idImage} 
                    modal={shapeImgModal} 
                    toggle={() => setShapeImgModal(!shapeImgModal)} 
                    addShapeImgHandler={addShapeImgHandler} 
                    index={shapeIndex} />
            }
        </>
    )
}
let validate = (str) => {
    let count = 0
    for (let i = 0; i < str.length; i++) {
        if ((str.charCodeAt(i) >= 65 && str.charCodeAt(i) <= 90) || (str.charCodeAt(i) >= 97 && str.charCodeAt(i) <= 122)) {
            count += 1
        }
    }

    return count >= 2 ? true : false

}

export default Shape